import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/** 路由配置表 */
const routes = [
  {
    // 登录页，无需布局容器
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    // 根路径，使用 Layout 布局，默认重定向到首页
    path: '/',
    component: () => import('@/components/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        // 首页仪表盘
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        // 轮播图管理页
        path: 'swiper',
        name: 'Swiper',
        component: () => import('@/views/swiper/Index.vue'),
        meta: { title: '轮播图管理', icon: 'el-icon-picture' }
      },
      {
        // 品牌管理列表页
        path: 'brand',
        name: 'Brand',
        component: () => import('@/views/brand/Index.vue'),
        meta: { title: '品牌管理', icon: 'el-icon-s-flag' }
      },
      {
        // 品牌详情页（新增/编辑），:id 为品牌 ID，new 表示新增
        path: 'brand/detail/:id',
        name: 'BrandDetail',
        component: () => import('@/views/brand/Detail.vue'),
        meta: { title: '品牌详情' }
      },
      {
        // 内容管理列表页
        path: 'content',
        name: 'Content',
        component: () => import('@/views/content/Index.vue'),
        meta: { title: '内容管理', icon: 'el-icon-document' }
      },
      {
        // 内容详情页（新增/编辑），:id 为内容 ID，new 表示新增
        path: 'content/detail/:id',
        name: 'ContentDetail',
        component: () => import('@/views/content/Detail.vue'),
        meta: { title: '内容详情' }
      },
      {
        // 产品分类管理页
        path: 'category',
        name: 'Category',
        component: () => import('@/views/category/Index.vue'),
        meta: { title: '产品分类', icon: 'el-icon-menu' }
      },
      {
        // 所有产品列表页
        path: 'product',
        name: 'Product',
        component: () => import('@/views/product/Index.vue'),
        meta: { title: '所有产品', icon: 'el-icon-goods' }
      },
      {
        // 产品详情页（新增/编辑），:id 为产品 ID，new 表示新增
        path: 'product/detail/:id',
        name: 'ProductDetail',
        component: () => import('@/views/product/Detail.vue'),
        meta: { title: '产品详情' }
      },
      {
        // 系统配置页
        path: 'config',
        name: 'Config',
        component: () => import('@/views/config/Index.vue'),
        meta: { title: '系统配置', icon: 'el-icon-setting' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

/**
 * 全局前置守卫
 * - 设置页面标题
 * - 未登录用户重定向到登录页，已登录用户访问登录页则重定向到首页
 */
router.beforeEach((to, from, next) => {
  document.title = (to.meta.title || 'EBIR') + ' - 管理后台'
  const token = localStorage.getItem('ebir_token')
  if (to.path === '/login') {
    token ? next('/') : next()
  } else {
    token ? next() : next('/login')
  }
})

export default router
